import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';
import { EthemeProvider } from '../../providers/etheme/etheme';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'clock',  
  templateUrl: 'clock.html',
})  
 
export class ClockComponent{ 

  @Input('ore') ore:number; 
  @Input('minuti') minuti:number; 
  @Input('startcolor') startcolor:string;  
  @Input('endcolor') endcolor:string; 
  @Input('dim') dim:string; 
  @Input('larghezza') larghezza:string;
  @Input('lingua') lingua:string;
  @Input('secondi') secondi:string;
  
  percentuale:any;
  rand:any;
  rand2:any;
  gradientname:any;
  uid_r:string = 'xxx';
  constructor(public events: Events,public etheme: EthemeProvider,public injector: Injector) {
  }
  update_output(){
  //  this.events.publish('aperta', this.domanda, this.risp);
  }
  ngOnInit(){
   //var per = 100 - this.percent;
   //this.percentuale = per + '%';
   //this.percentuale = 261 /100 *(100-this.percent);
   //this.percentuale = (100-this.percent)+'%';
  //  console.log(this.rand);
  //  this.percentuale = 265-(265/100*this.percent);
   //this.percentuale = 265-(265/100*this.percent);
  //  this.rand = Math.floor(Math.random() * 1000);
  //  this.gradientname = 'Gradient-'+this.rand;
  this.uid_r= this.guid();
  }
  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  guid() {
    return this.s4() + this.s4() + this.s4()  + this.s4();
    }

}



// WEBPACK FOOTER //
// ./src/pages/component/clock.ts